import { Button, Link } from "@mui/material";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as _appSer from "../../../../_redux/_services/ApplicantsSlice";
import { decrypt } from "../../../../_utilities/_encryptDecryptHelper";
import CustomDateRangePicker from "../../../../components/CustomDateRangePicker/CustomDateRangePicker";
import { DashboardExporticon } from "../../../../Icons/DashboardeExporticon";
import { DashboardImporticon } from "../../../../Icons/DashboardImporticon";
import { DashboardPlusicon } from "../../../../Icons/DashboardPlusicon";

import { getAttributes, GetUserInfo } from "../../../../_utilities/getUserInfo";
const DateTime = ({
  handleAddCard,
  handleSaveConfig,
  updateDate,
  reloadWidgets,
  editMode,
  setEditMode,
  handleExport,
  handleImport,
  handleCancelConfig,
}) => {
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState(
    dayjs().subtract(7, "day").toDate(),
  );
  const [endDate, setEndDate] = useState(new Date());
  const dispatch = useDispatch();

  const [countryId, setCountryId] = useState("");

  useEffect(() => {
    async function init() {
      const userInfo = await GetUserInfo();
      let userCountries = JSON.parse(userInfo[0].selectedcountries);
      setCountryId(userCountries[0].id);
    }
    init();
  }, []);

  const selectedCountry = JSON.parse(decrypt("selectCountry"));
  const allCountries = JSON.parse(decrypt("allCountryId"));
  const prevCountry = Cookies.get("selectCountryId")
    ? Cookies.get("selectCountryId")
    : countryId;

  const onLoadWidgetHandler = async () => {
    const formatStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formatEndDate = dayjs(endDate).format("YYYY-MM-DD");
    const getAttribute = await getAttributes();
    if (getAttribute.length > 0) {
      const payload = {
        startDate: formatStartDate,
        endDate: formatEndDate,
        userId: getAttribute[0].userId,
        countryId:
          allCountries === "all"
            ? allCountries
            : selectedCountry?.id
              ? selectedCountry?.id
              : prevCountry,
      };
      dispatch(_appSer.getResumeCountAsync(payload));
      dispatch(_appSer.getPieChartDataAsync(payload));
      dispatch(_appSer.getBarChartDataAsync(payload));
      fetchRequirementAssigned(getAttribute[0].userId);
    }
  };

  useEffect(() => {
    onLoadWidgetHandler();
  }, []);

  useEffect(() => {
    const formatStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formatEndDate = dayjs(endDate).format("YYYY-MM-DD");
    updateDate({
      startDate: formatStartDate,
      endDate: formatEndDate,
    });
  }, [startDate, endDate]);

  const toggle = () => setOpen(!open);

  const handleDateChange = (range) => {
    setStartDate(range.startDate);
    setEndDate(range.endDate);
    //  setDateRange(range);
    setOpen(false);
  };

  const handleForceSave = () => {
    handleSaveConfig();
    onLoadWidgetHandler();
  };

  const fetchRequirementAssigned = (userId) => {
    let data = {
      limit: 10,
      offSet: 1,
      userId: userId,
      countryId:
        allCountries === "all"
          ? allCountries
          : selectedCountry?.id
            ? selectedCountry?.id
            : prevCountry,
    };
    dispatch(_appSer.getRequirementAssignedAsync(data));
  };

  return (
    <div className="date-time-toolbar-container">
      {!editMode && (
        <div className="dashbaord__date-time-container">
          {/* <Grid container spacing={3}> */}
          {/* <Grid item xs={4}> */}
          {/* <div className="educationTermRangePicker">
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  autoComplete="off"
                  label="Start Date"
                  placeholder="Start Date"
                  style={{ width: "50%" }}
                  name="startdate"
                  value={startDate.toLocaleDateString()}
                  onClick={() => setOpen(true)}
                  InputLabelProps={{
                    style: {
                      fontWeight: "bold",
                    },
                  }}
                />
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  autoComplete="off"
                  label="End Date"
                  placeholder="End Date"
                  style={{ width: "50%" }}
                  name="enddate"
                  value={endDate.toLocaleDateString()}
                  onClick={() => setOpen(true)}
                  InputLabelProps={{
                    style: {
                      fontWeight: "bold",
                    },
                  }}
                />
              </div> */}
          {/* <DateRangePicker
                open={open}
                toggle={toggle}
                maxDate={new Date()}
                onChange={handleDateChange}
              /> */}
          <CustomDateRangePicker
            handleDateChange={(range) => handleDateChange(range)}
            dateValue={{ startDate: startDate, endDate: endDate }}
          />
          {/* </Grid> */}
          {/* <Grid item xs={3}> */}
          <Button
            variant="contained"
            style={{
              backgroundColor:
                !startDate || !endDate
                  ? "#f5f5f5"
                  : "var(--secondary-bg-color)",
              color: "var(--secondary-background-text-color)",
              borderRadius: "10px",
              textTransform: "capitalize",
              width: "92px",
              font: "normal normal normal 0.875rem Roboto",
              height: "47px",
              fontWeight: "600",
              fontSize: "14px",
              marginTop: "5px",
              marginLeft: "10px",
            }}
            onClick={() => {
              onLoadWidgetHandler();
              reloadWidgets();
            }}
            disabled={!startDate || !endDate}
          >
            Reload
          </Button>
          {/* </Grid> */}
          {/* </Grid> */}
        </div>
      )}
      <div className="dashboard__toolbar">
        {editMode && (
          <div className="button-group">
            <div className="action-button" onClick={handleAddCard}>
              <DashboardPlusicon />
              <span>Add</span>
            </div>
            <div className="action-button" onClick={handleExport}>
              <DashboardExporticon />
              <span>Export</span>
            </div>
            <div className="action-button" onClick={handleImport}>
              <DashboardImporticon />
              <span>Import</span>
            </div>
          </div>
        )}
      </div>
      <div>
        {editMode && (
          <Button
            type="button"
            className="cancelBtn"
            onClick={() => {
              handleCancelConfig();
            }}
          >
            <Link href="#" style={{ color: "red", fontSize: "14px" }}>
              {" "}
              Cancel
            </Link>
          </Button>
        )}
        <Button
          onClick={() => (editMode ? handleForceSave() : setEditMode(true))}
          className="dashboard__toolbar-button"
          variant="contained"
          disabled={!startDate || !endDate}
        >
          {editMode ? "Save" : "Edit"}
        </Button>
      </div>
    </div>
  );
};

export default React.memo(DateTime);
